// extracted by mini-css-extract-plugin
export default {"intro":"intro_intro__L0BZ+","introContent":"intro_introContent__Chs3q","introTitle":"intro_introTitle__qMIiI","introText":"intro_introText__ji5EZ"};